import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { cacheVersionInterceptor } from '@core/interceptors/cache-version.interceptor';
import { globalLoadingInterceptor } from '@core/interceptors/global-loading.interceptor';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([globalLoadingInterceptor, authInterceptor, cacheVersionInterceptor])
    ),
    provideLottieOptions({
      player: () => player,
    }),
    providePrimeNG({
      theme: {
        preset: Aura,
      },
    }),
  ],
};
